import { REASONS } from "@/app/calculator/constants/calculatorData";
import { OptionButton, CircleButton, StepLabel } from "./Ui";
import { PlusCircle, LayoutGrid, RefreshCw, FileText,  } from "lucide-react";

const REASON_ICONS = {
  new: <PlusCircle size={16} />,
  expansion: <LayoutGrid size={16} />,
  relocation: <RefreshCw size={16} />,
  visa: <FileText size={16} />,
};

const SHAREHOLDER_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8];
const VISA_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7];

export function StepDetails({ data, onChange }) {
  return (
    <div className="space-y-6">

      {/* Header */}
      <StepLabel
        tag="Details"
        title="Tell us about your setup"
        description="What is your main reason for setting up a company in the UAE?"
      />

      {/* Reason Options */}
      <div className="space-y-2">
        {REASONS.map((r) => (
          <OptionButton
            key={r.id}
            id={r.id}
            label={r.label}
            icon={REASON_ICONS[r.id]}
            selected={data.reason === r.id}
            onClick={(id) => onChange("reason", id)}
          />
        ))}
      </div>

      {/* Shareholders */}
      <div className="space-y-2">
        <p className="text-sm sm:text-base font-semibold text-gray-700">
          How many owners / shareholders?
        </p>

        <div className="flex flex-wrap gap-2">
          {SHAREHOLDER_OPTIONS.map((n) => (
            <CircleButton
              key={n}
              value={n}
              selected={data.shareholders === n}
              onClick={(v) => onChange("shareholders", v)}
            />
          ))}
        </div>
      </div>

      {/* Visas */}
      <div className="space-y-2">
        <p className="text-sm sm:text-base font-semibold text-gray-700">
          How many residence visas do you need?
        </p>

        <div className="flex flex-wrap gap-2">
          {VISA_OPTIONS.map((n) => (
            <CircleButton
              key={n}
              value={n}
              selected={data.visas === n}
              onClick={(v) => onChange("visas", v)}
            />
          ))}
        </div>
      </div>

    </div>
  );
}
